import { useState, useEffect, useCallback } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';


export const useScrollRestore = ({ page, path }) => {
  const history = useHistory();
  const [lastScrollY, setLastScrollY] = useState(() => localStorage.getItem(`${page}_lastScrollY`));
  const match = useRouteMatch(path);
  const scrollSave = useCallback(() => {
    console.log('scrollSave')
    const scrollPos = window.scrollY;
    setLastScrollY(scrollPos);
    return localStorage.setItem(`${page}_lastScrollY`, scrollPos);
  }, []);

  const clearLastScrollY = useCallback(() => {
    console.log('clearLastScrollY')
    setLastScrollY(0);
    localStorage.removeItem(`${page}_lastScrollY`);
  }, []);

  useEffect(() => {
    console.log('== load scrollRestore ==')
    console.log('history - ', history)
    console.log('match - ', match)

    return history.listen((location) => {
      if (location.pathname !== path) {
        scrollSave();
      }
    });
  }, []);

  return { lastScrollY, clearLastScrollY };
};
